import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useHasHistory } from '../../hooks';
import { IconLabel } from '../IconLabel';

import classes from './BackButton.module.scss';

interface BackButtonProps {
  color?: string;
}

export const BackButton: FunctionComponent<BackButtonProps> = memo(({ color = '#43445b' }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const hasHistory = useHasHistory();

  if (!hasHistory) {
    return null;
  }

  return (
    <div className={classes['back-button']}>
      <IconLabel
        iconId={'arrow-rounded-left'}
        iconSize={18}
        label={t('common.back')}
        labelClassName={classes['back-button__label']}
        onClick={() => navigate(-1)}
        color={color}
        singleColor
      />
    </div>
  );
});
